<template>
    <div style="text-align: left">
        <div class="list">全部批次</div>
        <div class="content">
            <div class="goods">
                <div style="flex:2;display: flex; ">
                    <div style="margin-right: 20px;">
                        学校名称：<el-input placeholder="请输入学校名称" :disabled="batchFlag" class="input-with-select"
                            style="max-width: 200px;" v-model="batchList.schoolName"></el-input>
                        批次名称：<el-input placeholder="请输入批次名称" :disabled="batchFlag" class="input-with-select"
                            style="max-width: 200px;" v-model="batchList.batchName"></el-input>
                        开始时间：<el-date-picker placeholder="请输入批次开始时间" :disabled="batchFlag" v-model="batchList.startTime"
                            type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        结束时间：<el-date-picker placeholder="请输入批次开始时间" :disabled="batchFlag" v-model="batchList.endTime"
                            type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                        <el-checkbox style="margin-left: 10px;" v-model="batchFlag" label="最近结束" border></el-checkbox>
                    </div>
                    <el-button @click="search" type="primary" style="height: 32px;">搜 索</el-button>
                    <el-button @click="reset" style="margin-left: 20px;height: 32px;" type="primary" plain>重 置</el-button>
                    <el-button @click="returnPage" style="margin-left: 20px;height: 32px;" type="primary" plain>返
                        回</el-button>
                </div>
                <br />
                <hr>
                <!-- <div style="margin-top: 20px">
                    <el-button type="primary" plain @click="openDialog('ruleForm')">新增批次</el-button>
                    <el-button type="primary" plain>批量删除</el-button>
                </div> -->
            </div>
            <br />
            <div class="global-table-box">
                <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange"
                    :cell-style="{ padding: '18px 0' }" header-align="center">
                    <!-- <el-table-column type="selection" width="55" align="center">
                </el-table-column> -->
                    <el-table-column type="index" width="50" label="序号" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="schoolName" label="学校名称" width="300" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="batchName" label="批次名称" width="300" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="batchLabel" label="订购类型" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="logisticsType" label="配送方式" width="200" header-align="center" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="通知" header-align="center" align="center" width="300">
                        <template slot-scope="scope">
                            <el-tooltip class="item" effect="light" :content="scope.row.noticeContent" placement="bottom">
                                <template slot="content">
                                    <p class="notice" style="max-width:200px;">{{ scope.row.noticeContent }}</p>
                                </template>
                                <div class="notice-content"> {{ scope.row.noticeContent }}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="phone" label="客服电话" width="200" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="startTime" label="开始时间" header-align="center" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="endTime" label="结束时间" width="200" header-align="center" align="center">
                    </el-table-column>
                    <!-- <el-table-column label="操作" header-align="center" align="center" fixed="right" width="400px">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="editorEcho(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="openProlong(scope.row)">延期</el-button>
                            <el-button type="text" size="small" @click="openResetProlong(scope.row)">重置</el-button>
                            <el-button @click="deleteBatch(scope.row)" type="text" size="small">删除</el-button>
                            <el-button @click="addGrade(scope.row)" type="text" size="small">添加年级</el-button>
                            <el-button @click="batchGrade(scope.row, 'batchGoods')" type="text"
                                size="small">批次商品</el-button>
                            <el-button type="text" size="small" @click="openCode(scope.row)">生成二维码</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
            <div class="block">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="batchList.pageNum"
                    layout="prev, pager, next, jumper" :total="total" :page-size="10">
                </el-pagination>
            </div>

        </div>



    </div>
</template>


<script>
import request from '../utils/request'
export default {
    data() {
        return {
            batchFlag: false,
            batchList: {
                batchName: '',
                schoolName: '',
                endTime: '',
                startTime: '',
                isPage: true,
                pageNum: 1,
                pageSize: 10,
                batchFlag: 0
            },
            total: 0,
            tableData: []
        }
    },
    methods: {

        // 返回上一页
        returnPage() {
            this.$router.go(-1)
        },
        // 批次查询
        async getBatch() {
            const res = await request({
                method: 'POST',
                url: 'admin/school/get/batchList',
                data: this.batchList
            })
            if (res.code === '200') {
                this.tableData = res.data && res.data.list
                this.total = res.data && res.data.total
            } else {
                this.$message.error(res.message)
            }
            //console.log(res);
        },
        // 搜索
        search() {
            this.batchList.pageNum = 1
            this.getBatch()
        },
        // 重置查询
        reset() {
            this.batchList.schoolName = ''
            this.batchList.batchName = ''
            this.batchList.pageNum = 1
            this.batchList.pageSize = 10
            this.batchList.isPage = true
            this.batchList.endTime = ""
            this.batchList.startTime = ""
            this.getBatch()
        },
        // 多选
        handleSelectionChange() { },
        // 分页
        handleCurrentChange() {
            this.getBatch()
        }
    },
    created() {

        this.getBatch()

    },
    mounted() { },
    watch: {
        batchFlag(newVal) {
            if (newVal) {
                this.batchList.batchName = ''
                this.batchList.schoolName = ''
                this.batchList.endTime = ''
                this.batchList.startTime = ''
                this.batchList.isPage = true
                this.batchList.pageNum = 1
                this.batchList.batchFlag = 1
            }else{
                this.batchList.batchFlag = 0
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.list {
    background-color: #2589ff;
    color: #fff;
    text-align: center;
    width: 106px;
    height: 36px;
    margin-right: 10px;
    font-size: 16px;
    line-height: 36px;
    display: inline-block;
    border-radius: 6px;
}

.content {
    margin: 20px 0 0 0;
    background-color: #e0e0e0;
    padding: 10px;
    border-radius: 5px;
}

.goods {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px;
    // display: flex;
    // justify-content: space-between;
}

.el-select .el-input {
    width: 130px;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}

.block {
    text-align: right;
    background-color: #fff;
}

.img-choose {
    height: 500px;
    overflow: auto;
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;

    .single-goods {
        width: 150px;
        position: relative;
        // background-color: red;
        margin: 0 10px 10px 10px;

        img {
            width: 100%;
            height: 150px;
        }
    }
}

.is-active {
    width: 100%;
    height: 20px;
    opacity: 0.5;
    background-color: #000;
    position: absolute;
    left: 0;
    top: 130px;
}

.img-search {
    margin-bottom: 20px;
    text-align: right;

    .el-input {
        width: 200px;
    }
}

.notice-content {
    height: 50px;
}

.left .el-tooltip__popper,
.right .el-tooltip__popper::v-deep {
    padding: 8px 10px;
}

#poster-aside {
    position: relative;
    background-color: #000;
    height: 600px;
    margin-bottom: 60px;

    .code-cont {
        // background-color: red;
        width: 400px;
        z-index: 99999;
        top: -20px;
        left: -20px;
        position: absolute;

        p {
            text-align: center;
            color: #fff;
        }

        .head-text {
            margin-top: 20px;
        }

        .title {
            margin-top: 30px;
            font-weight: bold;
        }

        .subscription-time {
            margin-top: 15px;
        }

        .cont {
            width: 320px;
            height: 500px;
            background-color: #fff;
            margin: 30px auto;
            border-radius: 10px;
            align-items: center;
            overflow: hidden;
            padding: 0 20px;

            .logo {
                position: relative;
                margin-top: 30px;

                // padding: 0 20px;
                img {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    top: -10px;
                }

                span {
                    font-size: 16px;
                    font-weight: bold;
                    margin-left: 50px;
                    color: #000;
                    display: block;
                }
            }

            .subscription-prompt {
                margin-top: 25px;
                font-weight: bold;
                color: #000;
                font-size: 14px;
            }

            .tow-code {
                width: 230px;
                height: 230px;
                background-color: #fafafa;
                margin: 25px auto 0;
                overflow: hidden;

                #qrcode {
                    width: 150px;
                    height: 150px;
                    // background-color: pink;
                    margin: 10px auto 0;
                }

                span {
                    padding: 0 15px;
                    margin-top: 15px;
                    display: block;
                    font-size: 1px;
                    text-align: center;
                }
            }

            .school-number {
                text-align: center;
                margin-top: 25px;
                font-weight: bold;
                color: #000;
            }

            .contact-number {
                text-align: center;
                margin-top: 10px;
                font-weight: bold;
                color: #000;
            }

            .company-name {
                text-align: center;
                margin-top: 10px;
            }
        }
    }

    .img {
        width: 400px;
        position: absolute;
        top: -20px;
        left: -20px;
    }
}

.el-dialog__body::v-deep {
    padding: 0 !important;
}

.poster-download {
    display: inline-block;
    background-color: #0ebfdf;
    padding: 4px 10px 5px;
    margin-left: 10px;
    position: relative;
    top: 2px;
    border-radius: 3px;
    cursor: pointer;
}

.dialog-footer {
    position: relative;

    .void-but {
        position: absolute;
        bottom: -10px;
        right: 0px;
    }
}

.itme {
    line-height: 40px;
    height: 10px;
}

.notice-content {
    height: 20px;
    overflow: hidden;
    padding: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>